var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var GAP = 16;

/**
 * Получение массива боксов элементов саджеста
 * @param {Node} row
 * @return {Array<DOMRect>}
 */
export var getRowRects = function getRowRects(row) {
    if (!row) {
        return [];
    }

    var children = row.children;


    if (!children) {
        return [];
    }

    var length = children.length;

    var rects = [];

    for (var i = 0; i < length; i++) {
        rects.push(children[i].getBoundingClientRect());
    }

    return rects;
};

/**
 * Получение наилучшего индекса для разделения массива
 * с точки зрения заполнения пространства элементами.
 * При этому учитывается порядок элементов.
 * @param {Array<DOMRect>} rows
 * @return {Number}
 */
export var getBestBalancePoint = function getBestBalancePoint(rows) {
    if (rows.length <= 1) {
        return -1;
    }

    var _rows = _slicedToArray(rows, 2),
        row1 = _rows[0],
        row2 = _rows[1];

    var row1Width = row1.reduce(function (aux, _ref) {
        var width = _ref.width;
        return aux + width;
    }, 0);
    var row2Width = row2.reduce(function (aux, _ref2) {
        var width = _ref2.width;
        return aux + width;
    }, 0);

    if (row2Width <= 0 || row1Width === row2Width) {
        return -1;
    }

    var coef = void 0;
    var i = void 0;

    // Если первая строка больше второй, пробуем переместить
    // последний элемент первой строки на вторую строку.
    if (row1Width > row2Width) {
        i = row1.length - 1;
        coef = getCoef(row2Width, row1Width);

        while (i >= 0) {
            var width = row1[i].width;


            row1Width -= width;
            row2Width += width;

            var newCoef = getCoef(row2Width, row1Width);

            if (newCoef >= coef) {
                return i + 1;
            }

            coef = newCoef;
            i--;
        }
    }

    // Если вторая строка больше первой, пробуем переместить
    // первый элемент второй строки на первую строку
    i = 0;
    coef = getCoef(row1Width, row2Width);

    while (i < row2.length) {
        var width = row2[i].width;


        row1Width += width;
        row2Width -= width;

        var _newCoef = getCoef(row1Width, row2Width);

        if (_newCoef >= coef) {
            return i + row1.length;
        }

        coef = _newCoef;
        i++;
    }

    return -1;
};

export var getSteps = function getSteps(rows, containerRect) {
    var containerLeft = containerRect.left,
        containerWidth = containerRect.width;

    var items = rows.reduce(function (aux, row) {
        return [].concat(_toConsumableArray(aux), _toConsumableArray(row));
    }, []);
    var length = items.length;

    var steps = [0];
    var maxRight = 0;

    for (var i = 0; i < length; i++) {
        maxRight = Math.max(items[i].right, maxRight);
    }

    maxRight -= containerLeft;
    items.sort(function (a, b) {
        return a.left > b.left ? 1 : -1;
    });

    var offset = 0;
    for (var _i = 0; _i < length; _i++) {
        var rect = items[_i];

        if (rect.right - containerLeft - offset > containerWidth) {
            offset = rect.left - containerLeft;
            steps.push(-offset + GAP * 2);
        }
    }

    var stepsCount = steps.length;
    var singlePage = stepsCount === 1;

    if (!singlePage) {
        steps[0] = GAP;
        steps[stepsCount - 1] = -maxRight + containerWidth - GAP;
    }

    return steps;
};

var getCoef = function getCoef(a, b) {
    return a > b ? Math.abs(1 - b / a) : Math.abs(1 - a / b);
};